import data from '@/data'
import u from '@/util'
const {
  auth,
  firebase
} = data

const state = {
  user: undefined,
  cell: null,
  userCells: [],
  authRedirect: undefined,
  authorizationInProgress: false
}

const getters = {
  authenticated: state => !!state.user,
  currentUser: state => state.user || {},
  cell: state => state.cell,
  cellType: (state, getters, rootState) => {
    const item = (rootState.cell.items || []).find(_ => _['.key'] === state.cell)
    return item && item.type || 'O'
  },
  hasAnyRole: state => roles => {
    // console.log('hasAnyRole', roles, state.user.role)
    return roles.includes(state.user.role)
  },
  readOnly: (state, getters) => !state.user || getters.hasAnyRole(['P'])
}

const mutations = {
  user(state, {
    user,
    cell,
    role,
    name,
    userCells
  }) {
    // console.log('mutation user', user, cell, role)
    // Copy data, otherwise it will throw: [vuex] Do not mutate vuex store state outside mutation handlers
    if (user) {
      state.user = {
        email: user.email,
        displayName: name,
        photoURL: user.photoURL,
        role: role,
        cell: cell
      }
      state.cell = cell
      state.userCells = userCells || (cell ? [cell] : [])
    } else {
      state.user = null
      state.userCells = []
    }

    // JSON.parse(JSON.stringify(user))
    // if (user) {
    //   console.log('commit user', user.role, state.user.role)
    // }
  },
  cell(state, payload) {
    state.cell = payload
  },
  redirect(state, redirect) {
    state.authRedirect = redirect
  },
  authorizationInProgress(state, payload) {
    state.authorizationInProgress = payload
  }
}

const actions = {
  // create ({ commit }, { email, password }) {
  //   return auth.createUserWithEmailAndPassword(email, password)
  //     // .then(user => { commit('signIn', user); return user })
  //     // .catch(error => commit('error', error))
  // },
  signInWithProvider(context, social) {
    var provider
    switch (social) {
      case 'google':
        provider = new firebase.auth.GoogleAuthProvider()
        break
      case 'facebook':
        provider = new firebase.auth.FacebookAuthProvider()
        break
    }

    context.commit('authorizationInProgress', true)
    return auth.signInWithPopup(provider)
      .then(result => console.log('sign in ', result))
      .catch(error => {
        console.error(error)
        context.commit('error', error)
        context.commit('authorizationInProgress', false)
      })
      .finally(() => console.log('finally'))
  },

  signInWithPassword(context, {
    email,
    password
  }) {
    context.commit('authorizationInProgress', true)
    // console.log('action signInWithPassword', { email, password })
    return auth.signInWithEmailAndPassword(email, password)
      .then(result => console.log('sign in ', result))
      .catch(error => {
        console.error(error)
        error.params = email
        context.commit('error', error)
        context.commit('authorizationInProgress', false)
      })
  },

  signOut(context) {
    // console.log('action signOut')
    context.commit('authorizationInProgress', false)
    return auth.signOut().then(() =>
      context.dispatch('navigate', {
        path: '/signin'
      })
    )
  },

  authorize(context) {
    // console.log('authorize', state.user)
    if (state.user) {
      return Promise.resolve(state.user)
    } else {
      const deferred = new Deferred()
      authorizations.push(deferred)
      return deferred.promise
    }
  }
}

class Deferred {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject
      this.resolve = resolve
    })
  }
}

var authorizations = []

// let promise = new Promise(function (resolve, reject) {})

export function onAuthStateChange(context, router) {
  // let routerInitialized = false
  return data.auth.onAuthStateChanged(async user => {
    // console.log('onAuthStateChange ', user ? user.email : user)
    if (user) {
      const email = user.email || user.user.email
      const person = await context.dispatch('getByEmail', email)

      if (!person) {
        context.commit('error', u.error('No user with such email', email))
        return
      }

      const userCells = person.cell ? person.cell.split(/[,;，]/).map(s => s.trim()).filter(Boolean) : []
      const cell = userCells[0]
      const cellItem = cell && await context.dispatch('cell/cell', cell)
      if (!cellItem) {
        context.commit('error', u.error('User cell does not exist', cell))
        return
      }

      const role = person.role
      const data = {
        email
      }
      if (user.providerData) {
        data.photoURL = user.providerData[0].photoURL
        data.displayName = user.providerData[0].displayName
      }
      setUser(data, cell, role, person.name, userCells)

      if (cell) {
        await Promise.all([
          context.dispatch('config', cell),
          context.dispatch('cell/names'),
          context.dispatch('cell/cells'),
          context.dispatch('cell/bind'),
          context.dispatch('assignment/bind', cell),
          context.dispatch('meeting/dates', cell),
          context.dispatch('meeting2/bindAssignments', cell),
          context.dispatch('meeting2/dates', cell)
        ])
      }

      const roles = state.authRedirect && state.authRedirect.roles || ['L', 'AL', 'SL', 'ASL', 'A', 'P']
      // if (context.getters.hasAnyRole(['A'])) {
      //   await context.dispatch('cell/bind')
      //   context.dispatch('navigate', { path: '/cells' })
      // } else
      if (context.getters.hasAnyRole(roles)) {
        // console.log('navigate meeting'
        const path = state.authRedirect && state.authRedirect.path !== '/' ? state.authRedirect.path :
          context.getters.hasAnyRole(['A', 'P']) ? '/cells' : '/meeting2'
        context.dispatch('navigate', {
          path
        })
      } else {
        context.commit('redirect', null)
        context.commit('error', u.error('Role does not have access', {
          email,
          role,
          roles
        }))
        context.dispatch('signOut')
      }
      // console.log('authorizations', authorizations)

      authorizations.forEach(a => a.resolve())
      authorizations = []
    } else {
      setUser(null, null, null)
      // context.dispatch('assignment/unbind')
    }

    function setUser(user, cell, role, name, userCells) {
      context.commit('user', {
        user,
        cell,
        role,
        name,
        userCells
      })
      if (context.state.authRedirect) {
        context.dispatch('navigate', {
          path: context.state.authRedirect.path
        })
        context.commit('redirect', undefined)
      }
    }
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}
